import { c as _c } from "react/compiler-runtime";
import type { ApiWaveMetadataType } from "@/generated/models/ApiWaveMetadataType";
import type { CreateWaveDropsRequiredMetadata } from "@/types/waves.types";
import CreateWaveDropsMetadataRowType from "./CreateWaveDropsMetadataRowType";
export default function CreateWaveDropsMetadataRow(t0) {
  const $ = _c(37);
  const {
    item,
    index,
    isNotUnique,
    onItemChange,
    onItemRemove
  } = t0;
  let t1;
  if ($[0] !== index || $[1] !== item.type || $[2] !== onItemChange) {
    t1 = event => {
      onItemChange({
        index,
        key: event.target.value,
        type: item.type
      });
    };
    $[0] = index;
    $[1] = item.type;
    $[2] = onItemChange;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const onKeyChange = t1;
  let t2;
  if ($[4] !== index || $[5] !== item.key || $[6] !== onItemChange) {
    t2 = type => {
      onItemChange({
        index,
        key: item.key,
        type
      });
    };
    $[4] = index;
    $[5] = item.key;
    $[6] = onItemChange;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const onTypeChange = t2;
  let t3;
  if ($[8] !== item.type || $[9] !== onTypeChange) {
    t3 = <CreateWaveDropsMetadataRowType activeType={item.type} onTypeChange={onTypeChange} />;
    $[8] = item.type;
    $[9] = onTypeChange;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const t4 = `required_metadata_key_${index}`;
  const t5 = `${isNotUnique ? "tw-border-error tw-ring-error focus:tw-border-error focus:tw-ring-error" : "tw-border-iron-650 tw-ring-iron-650  focus:tw-border-blue-500  focus:tw-ring-primary-400"} tw-form-input tw-block tw-px-4 tw-pb-3 tw-pt-4 tw-w-full tw-text-base tw-rounded-r-lg tw-border-0 tw-appearance-none ${item.key ? "focus:tw-text-white tw-text-primary-400" : "tw-text-white"} tw-peer tw-bg-iron-900 focus:tw-bg-iron-900 tw-font-medium tw-caret-primary-300 tw-shadow-sm tw-ring-1 tw-ring-inset placeholder:tw-text-iron-500 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-inset tw-transition tw-duration-300 tw-ease-out`;
  let t6;
  if ($[11] !== item.key || $[12] !== onKeyChange || $[13] !== t4 || $[14] !== t5) {
    t6 = <input type="text" value={item.key} onChange={onKeyChange} id={t4} autoComplete="off" className={t5} placeholder=" " />;
    $[11] = item.key;
    $[12] = onKeyChange;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== index || $[17] !== onItemRemove) {
    t7 = () => onItemRemove(index);
    $[16] = index;
    $[17] = onItemRemove;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <svg className="tw-top-4 tw-cursor-pointer tw-absolute tw-right-3 tw-h-5 tw-w-5" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t9;
  if ($[20] !== t7) {
    t9 = <div role="button" aria-label="Remove item" className="tw-text-iron-300 hover:tw-text-iron-400 tw-transition tw-duration-300 tw-ease-out" onClick={t7}>{t8}</div>;
    $[20] = t7;
    $[21] = t9;
  } else {
    t9 = $[21];
  }
  const t10 = `required_metadata_key_${index}`;
  const t11 = `${isNotUnique ? "peer-focus:tw-text-error tw-text-error" : "peer-focus:tw-text-primary-400 tw-text-iron-500"} tw-absolute tw-cursor-text tw-text-base tw-font-normal tw-duration-300 tw-transform -tw-translate-y-4 tw-scale-75 tw-top-2 tw-z-10 tw-origin-[0] tw-bg-iron-900 peer-focus:tw-bg-iron-900 tw-px-2 peer-focus:tw-px-2 peer-placeholder-shown:tw-scale-100 peer-placeholder-shown:-tw-translate-y-1/2 peer-placeholder-shown:tw-top-1/2 peer-focus:tw-top-2 peer-focus:tw-scale-75 peer-focus:-tw-translate-y-4 rtl:peer-focus:tw-translate-x-1/4 rtl:peer-focus:tw-left-auto tw-start-1`;
  let t12;
  if ($[22] !== t10 || $[23] !== t11) {
    t12 = <label htmlFor={t10} className={t11}>Name</label>;
    $[22] = t10;
    $[23] = t11;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t12 || $[26] !== t6 || $[27] !== t9) {
    t13 = <div className="tw-relative tw-w-full">{t6}{t9}{t12}</div>;
    $[25] = t12;
    $[26] = t6;
    $[27] = t9;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  let t14;
  if ($[29] !== t13 || $[30] !== t3) {
    t14 = <div className="tw-flex">{t3}{t13}</div>;
    $[29] = t13;
    $[30] = t3;
    $[31] = t14;
  } else {
    t14 = $[31];
  }
  let t15;
  if ($[32] !== isNotUnique) {
    t15 = isNotUnique && <div className="tw-ml-24"><div className="tw-pt-1.5 tw-text-error tw-text-xs tw-font-medium"><div className="tw-flex tw-items-center tw-gap-x-2"><svg className="tw-size-5 tw-flex-shrink-0 tw-text-error" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 8V12M12 16H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg><span>Metadata name must be unique</span></div></div></div>;
    $[32] = isNotUnique;
    $[33] = t15;
  } else {
    t15 = $[33];
  }
  let t16;
  if ($[34] !== t14 || $[35] !== t15) {
    t16 = <div>{t14}{t15}</div>;
    $[34] = t14;
    $[35] = t15;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}